

































































































































































































































import Vue from 'vue'
import BoxContainer from '@/components/BoxContainer.vue'
import AmendmentLogDetailsPanel from "@/components/amendments/AmendmentLogDetailsPanel.vue";
import { AmendmentViewModel } from "@/models/AmendmentViewModel";
import { AmendmentDocumentViewModel} from "@/models/AmendmentDocumentViewModel";
import AmendmentDetailsPanel from "@/components/amendments/AmendmentDetailsPanel.vue";
import AmendmentApplicantDetailsPanel from "@/components/amendments/AmendmentApplicantDetailsPanel.vue";
import {UserViewModel} from "@/models/UserViewModel";
import {StatusUpdateViewModel} from "@/models/StatusUpdateViewModel";
import {ReturnDataViewModel} from "@/models/ReturnDataViewModel";


export default Vue.extend( {
  name: "AmendmentDetail",
  components: {
    AmendmentApplicantDetailsPanel,
    AmendmentDetailsPanel,
    BoxContainer ,
    AmendmentLogDetailsPanel
  },
  data(): {
    itemId: number;
    isShowSubmit: boolean;
    amendment: AmendmentViewModel;
    documentList: AmendmentDocumentViewModel[];
    statusAndNoteViewModel: StatusUpdateViewModel;
    isReady: any;
    fileNames: any;
    assignedToMessage: string;
    dialogWithdraw: boolean;
    fileSizes: any;
  } {
    return {
      itemId: 0 ,
      isShowSubmit: false ,
      amendment: {} as AmendmentViewModel ,
      documentList: [] as AmendmentDocumentViewModel[],
      statusAndNoteViewModel: {} as StatusUpdateViewModel ,
      isReady: {
        isAlcLetter: false ,
        isAdwfCalculation: false ,
        isPwwfCalculation: false ,
        isCouncilReport: false ,
        isLocationMap: false ,
        isSiteMap: false ,
      } as any ,
      fileNames: {
        alcLetter: "",
        adwfCalculation: "",
        pwwfCalculation: "",
        councilReport: "" ,
        locationMap: "",
        siteMap: ""
      },
      fileSizes: {
        alcLetter: 0 ,
        adwfCalculation: 0 ,
        pwwfCalculation: 0 ,
        councilReport: 0 ,
        locationMap: 0 ,
        siteMap: 0 ,
      } as any,
      assignedToMessage: "",
      dialogWithdraw: false
    }
  },
  computed: {
    apiURL() {
      return process.env.VUE_APP_API_URL
    },
    isReadyForSubmissionDetail():boolean {
      let isReadyForSubmit = false;
      if ( this.amendment.isInLandReserve ) {
        isReadyForSubmit =  (this.isReady.isAlcLetter && this.isReady.isAdwfCalculation && this.isReady.isPwwfCalculation && this.isReady.isCouncilReport && this.isReady.isLocationMap && this.isReady.isSiteMap);
      } else {
        isReadyForSubmit =  (this.isReady.isAdwfCalculation && this.isReady.isPwwfCalculation && this.isReady.isCouncilReport && this.isReady.isLocationMap && this.isReady.isSiteMap);
      }

      if ( this.totalFileSize >= 15728640) {
        isReadyForSubmit = false;
      }
      return isReadyForSubmit;
    },
    loggedInUser(): UserViewModel {
      return this.$store.state.loggedInUser;
    },
    totalFileSize():number {
      let totalSize = this.fileSizes.alcLetter + this.fileSizes.adwfCalculation + this.fileSizes.pwwfCalculation + this.fileSizes.councilReport + this.fileSizes.locationMap + this.fileSizes.siteMap;
      return totalSize;
    }
  },
  watch: {
  },
  methods: {
    async loadData() {

      // First get the base Amendment object
      let result = await this.axios.get('/Amendments/GetOne' , {
        params: {
          id: this.itemId
        }
      });
      this.amendment = result.data;

      // Handle the Currently Assigned To Message
      if ( this.amendment.currentlyAssignedTo ) {
        this.assignedToMessage = "( currently assigned to " + this.amendment.currentlyAssignedTo + " )";
      } else {
        this.assignedToMessage = "";
      }

      // Next we get the document list and calculate isReady
      let result2 = await this.axios.get( '/AmendmentDocuments/GetDocumentsForAmendment', {
        params: {
          amendmentId: this.itemId }
      });
      this.documentList = result2.data;

      // Handle Setting the controls for documents already uploaded
      for ( const n of this.documentList ){
        switch ( n.documentType ) {
          case "AlcLetter":
            this.isReady.isAlcLetter = true;
            this.fileNames.alcLetter = n.fileName;
            this.fileSizes.alcLetter = n.fileLength;
            break;
          case "AdwfCalculation":
            this.isReady.isAdwfCalculation = true;
            this.fileNames.adwfCalculation = n.fileName;
            this.fileSizes.adwfCalculation = n.fileLength;
            break;
          case "PwwfCalculation":
            this.isReady.isPwwfCalculation = true;
            this.fileNames.pwwfCalculation = n.fileName;
            this.fileSizes.pwwfCalculation = n.fileLength;
            break;
          case "CouncilReport":
            this.isReady.isCouncilReport = true;
            this.fileNames.councilReport = n.fileName;
            this.fileSizes.councilReport = n.fileLength;
            break;
          case "LocationMap":
            this.isReady.isLocationMap = true;
            this.fileNames.locationMap = n.fileName;
            this.fileSizes.locationMap = n.fileLength;
            break;
          case "SiteMap":
            this.isReady.isSiteMap = true;
            this.fileNames.siteMap = n.fileName;
            this.fileSizes.siteMap = n.fileLength;
            break;
          default:
        }
      }

    },
    async handleSubmit() {

      let result = await this.axios.get('/Amendments/SubmitAmendment' , {
        params: {
          id: this.itemId
        }
      });

      const data = result.data as unknown as ReturnDataViewModel;
      console.log(result);
      console.log(data);

      await this.$router.push( { name: "amendments-list" });

    },
    async handleWithdraw() {

      let result = await this.axios.get('/Amendments/WithdrawAmendment' , {
        params: {
          id: this.itemId
        }
      });

      // eslint-disable-next-line
      const data = result.data as unknown as ReturnDataViewModel;

      await this.$router.push( { name: "amendments-list" });

    },
    handleDocuments() {
      this.$router.push({name: "amendments-documents", params: {id: this.itemId.toString() } } );
    },
    handleEdit() {
      this.$router.push( { name: "amendments-edit", params: { id: this.itemId.toString() } } );
    },
    handleApprovalRedirect() {
      this.$router.push( { name: "amendments-admin" , params: { id: this.itemId.toString() } } );
    },
    bytesForHuman(bytes: number, decimals = 2) : string {
      let units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB']

      let i = 0

      for (i; bytes > 1024; i++) {
        bytes /= 1024;
      }

      return parseFloat(bytes.toFixed(decimals)) + ' ' + units[i]
    },
  },
  mounted: async function () {
    // this.getItemId();
    await this.loadData();
  },
  beforeMount() {
    if ( this.$route.params.id ) {
      this.itemId = parseInt( this.$route.params.id );
    }
  },
  beforeCreate() {
    setTimeout( async () => {
      if ( this.$store.state.loggedInUser == null ) {
        //make one attempt to get the current user info
        try {
          let result = await this.axios.get('Users/GetUserFromToken');
          if ( result.status === 200 ) {
            await this.$store.dispatch('updateUser', result.data);
          }
        } catch ( err ) {
          if ( err.response.status === 400  ) {
            await this.$router.push('/Login');
          }
        }
      }
    } , 250 );
  },
} )

